import { styled } from "styled-components";
import { RouterProvider } from "react-router-dom";
import { unAuthRouter } from "./modules/unAuthRouter";
import { ErrorsHandler } from "components/ui/shared/ErrorsHandler";



export const UnauthenticatedApp = () => {
    
    return (
        <UnAuthAppWraper>
            <RouterProvider router={unAuthRouter}/>
            <ErrorsHandler/>
        </UnAuthAppWraper>
    );
}

const UnAuthAppWraper = styled.div`

    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: row;

    background: ${({theme}) => theme.colors.neutralSecondaryBackground};
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};
    justify-content: center;
    align-items: center; 

    form.loginContainerWrapper
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
    }

    span.loginDescription
    {
        font-weight: 300;
    }

    span.loginFooter
    {
        font-weight: 300;
        color: ${({theme}) => theme.colors.mutedForeground};
    }

    div.activateUserContainer
    {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`
